import type * as React from "react"
import CancelBg from "@/shared/assets/secondary-button/cancel-bg.svg?react"
import DefaultBg from "@/shared/assets/secondary-button/default-bg.svg?react"
import TransparentBg from "@/shared/assets/secondary-button/transparent-bg.svg?react"
import { cn } from "@/shared/lib/utils"
import { buttonBgFill } from "@/shared/ui/button-bg-fill"

type SecondaryButtonVariant = "default" | "cancel" | "transparent"

interface SecondaryButtonProps
	extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	variant?: SecondaryButtonVariant
}

const BG_MAP = {
	default: DefaultBg,
	cancel: CancelBg,
	transparent: TransparentBg,
} as const

function SecondaryButton({
	variant = "default",
	disabled,
	className,
	children,
	...props
}: SecondaryButtonProps) {
	const Bg = BG_MAP[variant]

	return (
		<button
			type="button"
			disabled={disabled}
			className={cn(
				"group relative isolate inline-flex h-9 w-full pressable items-center justify-center px-4",
				"text-2xl font-bold select-none",
				variant === "cancel" ? "text-[#282a33]" : "text-white",
				disabled && "pointer-events-none",
				className,
			)}
			{...props}
		>
			<Bg
				className={cn(
					"absolute inset-0 -z-10 size-full",
					variant === "default" && buttonBgFill({ disabled }),
				)}
				preserveAspectRatio="none"
				aria-hidden
			/>
			{children}
		</button>
	)
}

export type { SecondaryButtonProps, SecondaryButtonVariant }
export { SecondaryButton }
